/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

/**
 * RedisMonitoringApi - interface
 * 
 * @export
 * @interface RedisMonitoringApiInterface
 */
export interface RedisMonitoringApiInterface {
    /**
     * Forces an immediate Redis health check
     * @summary Force Redis health check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedisMonitoringApiInterface
     */
    forceHealthCheckRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Forces an immediate Redis health check
     * Force Redis health check
     */
    forceHealthCheck(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns Redis cache usage statistics
     * @summary Get Redis cache statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedisMonitoringApiInterface
     */
    getCacheStatisticsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns Redis cache usage statistics
     * Get Redis cache statistics
     */
    getCacheStatistics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns current Redis configuration settings
     * @summary Get Redis configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedisMonitoringApiInterface
     */
    getRedisConfigurationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns current Redis configuration settings
     * Get Redis configuration
     */
    getRedisConfiguration(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns current Redis health status and metrics
     * @summary Get Redis health status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedisMonitoringApiInterface
     */
    getRedisHealthRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns current Redis health status and metrics
     * Get Redis health status
     */
    getRedisHealth(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns a comprehensive Redis status summary
     * @summary Get Redis status summary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedisMonitoringApiInterface
     */
    getRedisStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns a comprehensive Redis status summary
     * Get Redis status summary
     */
    getRedisStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Resets Redis health check failure/success counters
     * @summary Reset Redis health check counters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedisMonitoringApiInterface
     */
    resetHealthCheckCountersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Resets Redis health check failure/success counters
     * Reset Redis health check counters
     */
    resetHealthCheckCounters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class RedisMonitoringApi extends runtime.BaseAPI implements RedisMonitoringApiInterface {

    /**
     * Forces an immediate Redis health check
     * Force Redis health check
     */
    async forceHealthCheckRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/redis/health/check`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Forces an immediate Redis health check
     * Force Redis health check
     */
    async forceHealthCheck(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.forceHealthCheckRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns Redis cache usage statistics
     * Get Redis cache statistics
     */
    async getCacheStatisticsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/redis/cache/statistics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns Redis cache usage statistics
     * Get Redis cache statistics
     */
    async getCacheStatistics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getCacheStatisticsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns current Redis configuration settings
     * Get Redis configuration
     */
    async getRedisConfigurationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/redis/configuration`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns current Redis configuration settings
     * Get Redis configuration
     */
    async getRedisConfiguration(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getRedisConfigurationRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns current Redis health status and metrics
     * Get Redis health status
     */
    async getRedisHealthRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/redis/health`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns current Redis health status and metrics
     * Get Redis health status
     */
    async getRedisHealth(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getRedisHealthRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns a comprehensive Redis status summary
     * Get Redis status summary
     */
    async getRedisStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/redis/status`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns a comprehensive Redis status summary
     * Get Redis status summary
     */
    async getRedisStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getRedisStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * Resets Redis health check failure/success counters
     * Reset Redis health check counters
     */
    async resetHealthCheckCountersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/redis/health/reset`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Resets Redis health check failure/success counters
     * Reset Redis health check counters
     */
    async resetHealthCheckCounters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.resetHealthCheckCountersRaw(initOverrides);
        return await response.value();
    }

}
